export default __webpack_public_path__ + "static/media/christmas-eve.4077e3aa.png";